import React, { useEffect, useState } from 'react'
import { Settings, Trash2, Link, ChevronRight } from 'lucide-react' // Import Link icon
import '../shared/AccordianStyle.css'
import { motion, AnimatePresence } from 'framer-motion'
import { CCol, CFormCheck, CFormInput, CFormTextarea, CRow, CTooltip, CButton, CNav, CNavItem, CNavLink, CTabContent, CTabPane, CFormSelect, CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody } from '@coreui/react'

const Accordions = ({ title, content, dropdownInput, setDropdownInput, idx, linkQuestion = true, linkQuestionCallback, showChevron = true, showDelete = true, showChain = true }) => {
  const [isOpen, setIsOpen] = useState(false)

  // const toggleAccordion = () => {
  //     if (!linkQuestion) {
  //         setIsOpen(!isOpen);
  //     } else {
  //         //   setActiveAccordion(isActive ? null : idx);
  //     }

  // };
  const toggleAccordion = () => {
    setIsOpen(!isOpen)
  }

  return (
    <div className="accordion-item w-full accordion-scope">
      <h2 className="accordion-header">
        <button
          className={`accordion-button custom-form-builder-theme__accordion-trigger ${!isOpen ? 'collapsed' : ''} ${isOpen ? 'custom-form-builder-theme__accordion-trigger--open' : ''} d-flex justify-content-between align-items-center`}
          type="button"
          onClick={toggleAccordion}
        >
          {title}

          <div>
            <span className="custom-icon ms-auto d-flex gap-1">
              {/* Show Link Icon only if linkQuestion is true */}
              {showChain && linkQuestion && (
                <Link
                  size={20}
                  strokeWidth={1.5}
                  onClick={() => {
                    // Call the linkQuestionCallback with the option name and index
                    linkQuestionCallback(dropdownInput.options[idx].label, idx)
                  }}
                />
              )}

              {/* Settings and Trash Icons */}
              {showChevron && <ChevronRight size={20} strokeWidth={1.5} onClick={toggleAccordion} style={{ transform: `${isOpen ? 'rotate(270deg)' : 'rotate(90deg)'}`, transition: 'transform 0.3s ease-in-out' }} />}

              {showDelete && linkQuestion && (
                <Trash2
                  size={20}
                  strokeWidth={1.5}
                  onClick={() => {
                    const updatedOptions = [...dropdownInput.options]
                    updatedOptions.splice(idx, 1)
                    setDropdownInput((prev) => ({ ...prev, options: updatedOptions }))
                  }}
                />
              )}
            </span>
          </div>
        </button>
      </h2>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div className="accordion-collapse" initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.3, ease: 'easeInOut' }}>
            <div className="accordion-body custom-form-builder-theme__accordion-body">{content}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}

export default Accordions
